import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import MUITabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

const TabsBase = styled(props => <MUITabs classes={{ indicator: 'indicator' }} {...props} />)`
  && {
    margin-left: 0;
    min-height: ${props => props.theme.spacing(3)}px;

    .indicator {
      height: 100%;
      border-radius: 4px;
      background-color: rgba(0, 103, 252, 0.05);
    }
  }
`;

const TabBase = styled(props => (
  <Tab classes={{ wrapper: 'label', root: 'labelContainer', selected: 'selected' }} {...props} />
))`
  && {
    text-transform: initial;
    margin: 0 ${props => props.theme.spacing(0.5)}px;
    min-width: 0;
    min-height: ${props => props.theme.spacing(3)}px;
    opacity: 0.5;

    &:first-child {
      margin-left: 0;
    }

    @media (min-width: ${props => props.theme.breakpoints.values.md}px) {
      min-width: 0;
    }

    &.selected {
      color: ${props => props.theme.palette.primary.main};
      opacity: 1;
    }

    .label {
      font-size: 13px;
      font-weight: 400;
      letter-spacing: initial;
    }

    .labelContainer {
      padding: ${props => props.theme.spacing(0.5)}px ${props => props.theme.spacing()}px;

      @media (min-width: ${props => props.theme.breakpoints.values.md}px) {
        padding: ${props => props.theme.spacing(0.5)}px ${props => props.theme.spacing()}px;
      }
    }
  }
`;

const Tabs = ({ tabs, current, onChange, ...props }) => (
  <TabsBase value={current} onChange={onChange} {...props}>
    {tabs &&
      tabs.map(({ label, path }) => (
        <TabBase label={label} key={path || label} value={path} disableRipple />
      ))}
  </TabsBase>
);

const tabShape = PropTypes.shape({
  label: PropTypes.string,
  path: PropTypes.string,
});

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(tabShape),
  current: PropTypes.string,
  onChange: PropTypes.func,
};

Tabs.defaultProps = {
  tabs: undefined,
  current: undefined,
  onChange: undefined,
};

export default Tabs;
